// extracted by mini-css-extract-plugin
export default {"themeFilter":"invert(93%) hue-rotate(180deg)","rightSidebarWidth":"302px"};